import { BaseItem, NullablePartial } from './common';

interface BaseProcedure {
  name: string;
  cptCode: string;
  organizationId: string | null;
}

export interface Procedure extends BaseProcedure, BaseItem {}
export type CreateValues = NullablePartial<BaseProcedure>;
export type UpdateValues = Partial<BaseProcedure>;

// patient app

export interface StandardProcedure {
  id: string;
  name: string;
  displayName: string;
  requireLaterality: boolean;
}

export enum Laterality {
  Bilateral = 'BILATERAL',
  Left = 'LEFT',
  Right = 'RIGHT',
}

export interface PrevisitProcedure {
  id: string;
  name: string;
  nameRaw: string;
  dateDay: number | null;
  dateMonth: number | null;
  dateYear: number | null;
  laterality: Laterality | null;
  comment: string | null;
  canRemove: boolean;
}
